import CharityListItem from '../components/CharityListItem';
import TextInput from '../components/TextInput';
import Layout from '../components/Layout';
import { useNavigate } from '@reach/router';

const CommentInput = ({
  senderName = 'Sara',
  senderInitial = 'S',
  value,
  onChange,
  placeholder = 'Thanks for the gift!',
  className = '',
}) => {
  return (
    <div
      className={`bg-[#f8f7fc] border border-[#eef2ff] border-solid content-stretch flex flex-col gap-[16px] items-start p-[21px] relative rounded-[24px] w-full ${className}`}
      data-name="Section"
      data-node-id="953:33488"
    >
      {/* Header Section */}
      <div
        className="relative shrink-0 w-full"
        data-name="Container"
        data-node-id="953:33489"
      >
        <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex gap-[12px] items-center relative w-full">
          {/* Avatar */}
          <div
            className="bg-[#1c2645] content-stretch flex items-center justify-center relative rounded-[9999px] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] shrink-0 size-[40px]"
            data-name="Background+Shadow"
            data-node-id="953:33490"
          >
            <div
              className="flex flex-col font-['Montserrat:Bold',sans-serif] font-bold justify-center leading-[0] relative shrink-0 text-[14px] text-center text-white whitespace-nowrap"
              data-node-id="953:33491"
            >
              <p className="leading-[20px]">{senderInitial}</p>
            </div>
          </div>
          {/* Question Text */}
          <div
            className="content-stretch flex flex-col items-start relative shrink-0"
            data-name="Container"
            data-node-id="953:33492"
          >
            <div
              className="flex flex-col font-['Montserrat:Bold',sans-serif] font-bold justify-center leading-[0] relative shrink-0 text-[#1f2937] text-[16px] whitespace-nowrap"
              data-node-id="953:33493"
            >
              <p className="leading-[24px]">Say thanks to {senderName}?</p>
            </div>
          </div>
        </div>
      </div>

      {/* Textarea Section */}
      <div
        className="bg-white border border-[#f3f4f6] border-solid relative rounded-[16px] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] shrink-0 w-full"
        data-name="Background+Border+Shadow"
        data-node-id="953:33494"
      >
        <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start pb-[12px] pt-[5px] px-[5px] relative w-full">
          <div
            className="relative rounded-[8px] shrink-0 w-full"
            data-name="Textarea"
            data-node-id="953:33495"
          >
            <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-start justify-center overflow-auto pb-[60px] pt-[12px] px-[12px] relative w-full">
              <div
                className="content-stretch flex flex-[1_0_0] flex-col items-start min-h-px min-w-px relative"
                data-name="Container"
                data-node-id="953:33496"
              >
                <textarea
                  value={value}
                  onChange={onChange}
                  placeholder={placeholder}
                  className="flex flex-col font-['Montserrat:Regular',sans-serif] font-normal justify-center leading-[0] relative shrink-0 text-[#0c2340] text-[16px] w-full bg-transparent border-none outline-none resize-none placeholder:text-[#9ca3af] placeholder:leading-[24px] placeholder:whitespace-pre-wrap min-h-[60px]"
                  data-node-id="953:33497"
                  rows={3}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Checkout = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-14 px-6">
      <CharityListItem amount={5000} className="mb-8" />
      <TextInput className="mb-4" placeholder="Your name" />
      <TextInput className="mb-8" placeholder="Email (for receipt)" />
      <CommentInput className="mb-8" />
      <button
        className="cz-btn-brand w-full"
        onClick={() => navigate(`/gift-redeem/confirmation`)}
      >
        Confirm Gift
      </button>
    </Layout>
  );
};

export default Checkout;
